import Comp_0 from "/home/runner/work/react-trace/react-trace/node_modules/.pnpm/@rspress+core@2.0.5_@types+mdast@4.0.4_@types+react@19.2.14_core-js@3.42.0_micromark-util-types@2.0.2_micromark@4.0.2/node_modules/@rspress/core/static/MediumZoom.tsx";
const Props_0 = {};
export default [[Comp_0, Props_0]];